import { render } from "./Stock.vue?vue&type=template&id=0dca22ee&ts=true"
import script from "./Stock.vue?vue&type=script&lang=ts"
export * from "./Stock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__